import dataLayerHelper from '../helpers/dataLayer';
import loadSelect2 from '../helpers/loadSelect2';

const $colorFilter = $('.js-color-filter');

const colorFilter = {
  initialize() {
    if ($colorFilter.length) {
      loadSelect2(() => {
        this.createSelect2();
      });
    }
  },

  createSelect2() {
    $colorFilter.on('select2:select', (e) => {
      const selection = $(e.currentTarget).select2('data');
      const { text } = selection[0];
      let parsedText = '';

      if (typeof text !== 'undefined') {
        parsedText = text.replace('\n', '').trim();
      }

      dataLayerHelper.event('Kleur selectie', 'change', parsedText);
    });

    $colorFilter.select2({
      width: '100%',
      templateResult: this.createOption,
      templateSelection: this.createOption,
    });
  },

  createOption(option) {
    const rgb = $(option.element).data('rgb');
    const html = `
      <span class="select2__color" style="background-color: rgb(${rgb})"></span>
      <span class="select2__color-text">${option.text}</span>
    `;

    return $(html);
  },
};

export default colorFilter;
